/**
 * Status karty podarunkowej DO POKAZANIA na liscie (nie to, co siedzi w bazie).
 *
 * W bazie kupony.status zna tylko 'aktywny' / 'wykorzystany' i NIE patrzy na date
 * waznosci. Kasa przy platnosci odrzuca karte po terminie ("Kupon wygasl"), ale
 * lista pokazywala ja jako "Aktywny" i wliczala do "Wartosci aktywnych" - kasjer
 * mowil klientowi "ma pan 70 zl", a kasa odmawiala. Wlasciciel (2026-09-11):
 * poprawic koniecznie. Stad trzeci stan 'wygasly' liczony tu, po stronie ekranu,
 * z tej samej reguly co backend (validate_coupon: data_waznosci < dzis => wygasl).
 */

// 'YYYY-MM-DD' z lokalnej daty (bez przesuniec strefy, jak toISOString by zrobil)
export function dzisISO(teraz = new Date()) {
  const y = teraz.getFullYear();
  const m = String(teraz.getMonth() + 1).padStart(2, '0');
  const d = String(teraz.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function czyPoTerminie(dataWaznosci, dzis = dzisISO()) {
  if (!dataWaznosci) return false;
  // data_waznosci to VARCHAR w bazie: bierzemy pierwsze 10 znakow ('2026-06-04' albo '2026-06-04 00:00:00')
  const d = String(dataWaznosci).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) return false;
  return d < dzis;
}

/** 'aktywny' | 'wygasly' | 'wykorzystany' */
export function statusKuponu(kupon, dzis = dzisISO()) {
  if (!kupon) return 'wykorzystany';
  if (kupon.status !== 'aktywny') return 'wykorzystany';
  return czyPoTerminie(kupon.data_waznosci, dzis) ? 'wygasly' : 'aktywny';
}

export const ETYKIETA_STATUSU = {
  aktywny: '✅ Aktywny',
  wygasly: '⏳ Wygasły',
  wykorzystany: '🔴 Wykorzystany',
};

/** Statystyki do boksow nad lista: aktywne liczone BEZ kart po terminie. */
export function statystykiKuponow(lista, dzis = dzisISO()) {
  const s = { active_count: 0, active_value: 0, expired_count: 0, expired_value: 0, used_count: 0, used_value: 0, total_count: 0 };
  for (const c of lista || []) {
    s.total_count += 1;
    const st = statusKuponu(c, dzis);
    const wartosc = parseFloat(c.wartosc || 0) || 0;
    if (st === 'aktywny') { s.active_count += 1; s.active_value += wartosc; }
    else if (st === 'wygasly') { s.expired_count += 1; s.expired_value += wartosc; }
    else { s.used_count += 1; s.used_value += parseFloat(c.kwota_wykorzystana || c.wartosc || 0) || 0; }
  }
  return s;
}
